<template>
  <div class="search-location">
    <div class="input-gruop-v">
      <div class="input mb_s">
        <div class="input-group">
          <div class="input-label">検索</div>
          <map-search @searchResult="(r) => { searchResult = r }"/>
        </div>
      </div>

      <template v-if="searchResult">
        <div>
          <div class="mb_s">
            <div class="input-label">場所名</div>
            {{ searchResult.formatted_address }}

            <div class="input-label">緯度</div>
            {{ searchResult.geometry.location.lat }}

            <div class="input-label">経度</div>
            {{ searchResult.geometry.location.lng }}
          </div>

          <div class="map">
            <google-map
              :location="searchResult.geometry.location"
              :radius="parseInt($store.state.quiz.radius)"
              @setGeo="setGeo"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import MapSearch from '@/components/Input/MapSearch'
import GoogleMap from '@/components/GoogleMap'

export default {
  components: {
    MapSearch,
    GoogleMap
  },

  data () {
    return {
      searchResult: null
    }
  },

  methods: {
    setGeo: function (location) {
      this.$store.commit(
        'quiz/setLat',
        location.lat
      )

      this.$store.commit(
        'quiz/setLng',
        location.lng
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
.map {
  height: 500px;
}

.search-location {
  border: $border;
  border-radius: 4px;
  padding: 20px;
}
</style>
